export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_AGENCY_ENG-9953c506c3c86b493344cfc5bb926f7f.pdf";